<template>
  <hs-card class="hs-chart-card" padding="none">
    <header class="hs-chart-card__header">
      <hs-section-header :kicker="kicker" :title="title" :description="description">
        <template v-if="$slots.actions" #actions>
          <slot name="actions" />
        </template>
      </hs-section-header>
    </header>
    <div class="hs-chart-card__body" :style="{ minHeight }">
      <div v-if="loading" class="hs-chart-card__state">
        <hs-skeleton variant="card" height="100%" />
      </div>
      <hs-empty-state
        v-else-if="empty"
        :icon="emptyIcon"
        :title="emptyTitle"
        :description="emptyDescription"
      />
      <slot v-else />
    </div>
    <footer v-if="$slots.footer" class="hs-chart-card__footer">
      <slot name="footer" />
    </footer>
  </hs-card>
</template>

<script>
import HsCard from "./HsCard.vue";
import HsEmptyState from "./HsEmptyState.vue";
import HsSectionHeader from "./HsSectionHeader.vue";
import HsSkeleton from "./HsSkeleton.vue";

export default {
  name: "HsChartCard",
  components: { HsCard, HsEmptyState, HsSectionHeader, HsSkeleton },
  props: {
    kicker: { type: String, default: "Analytics" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    empty: { type: Boolean, default: false },
    emptyIcon: { type: String, default: "bar-chart-2" },
    emptyTitle: { type: String, default: "No chart data" },
    emptyDescription: { type: String, default: "There is no chart data for the selected period." },
    minHeight: { type: String, default: "360px" },
  },
};
</script>

<style scoped>
.hs-chart-card {
  overflow: hidden;
}

.hs-chart-card__header,
.hs-chart-card__footer {
  border-bottom: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  padding: 1rem;
}

.hs-chart-card__footer {
  border-bottom: 0;
  border-top: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
}

.hs-chart-card__body {
  padding: 1rem;
}

.hs-chart-card__state {
  height: 100%;
  min-height: inherit;
}
</style>
